export default __webpack_public_path__ + "static/media/online-vehicle.26e56439.svg";